import styles from './IcecreamLogo.module.scss';
import { config } from '../../config';


const { ICECREAM_URL, ASSET_PREFIX } = config;
const IcecreamLogo = ({ href = ICECREAM_URL }): JSX.Element => {
  return (
    <div className={styles.icecreamLogo}>
      <a href={href} data-test="icecream-logo-header">
        <img 
          loading="lazy" 
          height="67"
          src={`${ASSET_PREFIX}/static/logo-icecream.svg`}
          alt="logo"
        />
      </a>
    </div>
  );
};

export default IcecreamLogo;
